import { Alert } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const AgreementSection = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 10px;
`;

export const TextareaWrapper = styled.div`
  width: 100%;
  textarea {
    width: 100%;
    height: 200px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    resize: none;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 20px;
`;



export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;
